export default [
   {
      path: '/establish/rebate',
      component: () => import( '@/views/loud/establish/rebate.vue'),
      meta: {
         title: '基础合同',
         isTabsPage: true,
         keepAlive: true
      }
   },
   {
      path: '/establish/agentContract',
      component: () => import( '@/views/loud/establish/agentContract.vue'),

   },
   {
      path: '/establish/contractlist',
      component: () => import( '@/views/loud/establish/contractlist.vue'),
       meta: {keepAlive:true, title: '目标退出',
          isTabsPage: true
       }

   },
   {
      path: '/establish/agentContractShenpi',
      component: () => import( '@/views/loud/establish/agentContractShenpi.vue'),

   },
   {
      path: '/establish/agentContractTuichuShenpi',
      component: () => import( '@/views/loud/establish/agentContractTuichuShenpi.vue'),

   },
   {
      path: '/establish/customerCountTable',
      component: () => import( '@/views/loud/establish/customerCountTable.vue'),
      meta: {
         title: '客户数量统计',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerCountTableLQ',
      component: () => import( '@/views/loud/establish/customerCountTableLQ.vue'),
      meta: {
         title: '客户数量统计(血液)',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerCountTableHH',
      component: () => import( '@/views/loud/establish/customerCountTableHH.vue'),
      meta: {
         title: '客户数量统计(厚宏)',
         isTabsPage: true,
         keepAlive:true
      }
   },

   {
      path: '/establish/customerFanliTable',
      component: () => import( '@/views/loud/establish/customerFanliTable.vue'),
      meta: {
         title: '客户返利报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTable',
      component: () => import( '@/views/loud/establish/customerLvyueTable.vue'),
      meta: {
         title: '客户履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerFanliTongji',
      component: () => import( '@/views/loud/establish/customerFanliTongji.vue'),
      meta: {
         title: '客户履约统计',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueXiaoshouTable',
      component: () => import( '@/views/loud/establish/customerLvyueXiaoshouTable.vue'),
      meta: {
         title: '客户履约报表销售',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/fanliJisuanSAP',
      component: () => import( '@/views/loud/establish/fanliJisuanSAP.vue'),
      meta: {keepAlive:true,title: '返利计算',
         isTabsPage: true
      }

   },
   {
      path: '/establish/fanliSapXiangqing',
      component: () => import( '@/views/loud/establish/fanliSapXiangqing.vue'),
   },
   {
      path: '/establish/etBellingList',
      component: () => import( '@/views/loud/establish/etBellingList.vue'),
   },
   {
      path: '/establish/flXsjlTarget',
      component: () => import( '@/views/loud/establish/flXsjlTarget.vue'),
      meta: {
         title: '目标导入详情',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/flXsjlTargetShenpi',
      component: () => import( '@/views/loud/establish/flXsjlTargetShenpi.vue'),
   },
   {
      path: '/establish/flGoalXiugaiShenpi',
      component: () => import( '@/views/loud/establish/flGoalXiugaiShenpi.vue'),
   },
   {
      path: '/establish/fanliJisuanYutiSaq',
      component: () => import( '@/views/loud/establish/fanliJisuanYutiSaq.vue'),
      meta: {keepAlive:true,title: '返利计算预提',
         isTabsPage: true
      }
   },
   {
      path: '/establish/etYuTiList',
      component: () => import( '@/views/loud/establish/etYuTiList.vue'),
   },
   {
      path: '/establish/chanPinTable',
      component: () => import( '@/views/loud/establish/chanPinTable.vue'),
      meta: {
         title: '产品报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/flCashDetail',
      component: () => import( '@/views/loud/establish/flCashDetail.vue'),
      meta: {
         title: '兑现明细报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/flInvoiceInfo',
      component: () => import( '@/views/loud/establish/flInvoiceInfo.vue'),
      meta: {
         title: '返利开票数据',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueQudaoTable',
      component: () => import( '@/views/loud/establish/customerLvyueQudaoTable.vue'),
      meta: {
         title: '2023履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueQudaoExitTable',
      component: () => import( '@/views/loud/establish/customerLvyueQudaoExitTable.vue'),
      meta: {
         title: '2023履约报表(退出)',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/flSamePeriodDiffer',
      component: () => import( '@/views/loud/establish/fl_same_period_differ.vue'),
      meta: {
         title: '同期差额报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/flRebateResultTable',
      component: () => import( '@/views/loud/establish/fl_rebate_result_table.vue'),
      meta: {
         title: '传统返利报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTable2024',
      component: () => import( '@/views/loud/establish/customerLvyueTable2024.vue'),
      meta: {
         title: '2024履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/lvyueTongji',
      component: () => import( '@/views/loud/establish/customerLvyueTongji2024.vue'),
      meta: {
         title: '客户履约分类统计',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/rebateCalculateTool',
      component: () => import( '@/views/loud/establish/rebateCalculateToolPart.vue'),
      meta: {keepAlive:true, title: '返利测算工具',
         isTabsPage: true
      }

   },
   {
      path: '/establish/rebateCalculateToolBlood',
      component: () => import( '@/views/loud/establish/rebateCalculateToolBlood.vue'),
      meta: {keepAlive:true, title: '返利测算工具-血液',
         isTabsPage: true
      }

   },
   {
      path: '/establish/rebateCalculateLog',
      component: () => import( '@/views/loud/establish/rebateCalculateLog.vue'),
      meta: {keepAlive:true, title: '返利测算记录',
         isTabsPage: true
      }

   },
   {
      path: '/establish/customerLvyueTable2025',
      component: () => import( '@/views/loud/establish/customerLvyueTable2025.vue'),
      meta: {
         title: '2025履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTable2025houhong',
      component: () => import( '@/views/loud/establish/customerLvyueTable2025houhong.vue'),
      meta: {
         title: '厚宏2025履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTable2026',
      component: () => import( '@/views/loud/establish/customerLvyueTable2026.vue'),
      meta: {
         title: '2026履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/allOrderSalesTable',
      component: () => import( '@/views/loud/establish/allOrderSalesTable.vue'),
      meta: {
         title: '全部销额报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/fxServiceSalesTable',
      component: () => import( '@/views/loud/establish/fxServiceSalesTable.vue'),
      meta: {
         title: '分销商安装量',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/fxServiceSalesDetailTable',
      component: () => import( '@/views/loud/establish/fxServiceSalesDetailTable.vue'),
      meta: {
         title: '分销商安装量明细',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/fxServiceNumTable',
      component: () => import( '@/views/loud/establish/fxServiceNumTable.vue'),
      meta: {
         title: '分销商上平台数',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/fxServiceNumDetailTable',
      component: () => import( '@/views/loud/establish/fxServiceNumDetailTable.vue'),
      meta: {
         title: '分销商上平台数明细',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTableAll',
      component: () => import( '@/views/loud/establish/customerLvyueTableAll.vue'),
      meta: {
         title: '累计履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTableLq',
      component: () => import( '@/views/loud/establish/customerLvyueTableLq.vue'),
      meta: {
         title: '2026血液履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTableLq2025',
      component: () => import( '@/views/loud/establish/customerLvyueTableLq2025.vue'),
      meta: {
         title: '2025血液履约报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
   {
      path: '/establish/customerLvyueTable2026Hou',
      component: () => import( '@/views/loud/establish/customerLvyueTable2026Hou.vue'),
      meta: {
         title: '2026厚宏履约报表',
         isTabsPage: true,
         keepAlive: true
      }
   },
    {
        path: '/establish/priceLevelAndLvyueStatusReport',
        component: () => import( '@/views/loud/establish/priceLevelAndLvyueStatusReport.vue'),
        meta: {
            title: '价格层级与履约状态报表',
            isTabsPage: true,
            keepAlive:true
        }
    },
   {
      path: '/establish/networkReteReport',
      component: () => import( '@/views/loud/network/networkCompliance.vue'),
      meta: {
         title: '网络达标率报表',
         isTabsPage: true,
         keepAlive:true
      }
   },
]
